<template>
  <div class="history-page">
    <v-app-bar app flat color="#1e1e1e" class="elevation-0">
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="reload" :disabled="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-app-bar>

    <v-container class="pt-0">
      <template v-if="loading">
        <div class="mt-4">
          <v-skeleton-loader
            v-for="i in 4"
            :key="i"
            class="mb-3"
            type="image, article"
            elevation="0"
          />
        </div>
      </template>

      <template v-else>
        <template v-if="orders.length === 0">
          <div class="empty-state d-flex flex-column align-center justify-center text-center">
            <v-img src="img/empty/empty-box.svg" width="120" class="mb-4" contain></v-img>
            <div class="text-subtitle-1 font-weight-bold mb-1">{{ $t('Ordered') }}</div>
            <div class="text-body-2 text--secondary">{{ $t('NoData') || 'No orders yet' }}</div>
            <v-btn class="mt-6" color="primary black--text" @click="$router.replace('/menu')">
              <v-icon left>mdi-silverware-fork-knife</v-icon>
              {{ $t('OrderNow') || 'Order now' }}
            </v-btn>
          </div>
        </template>

        <template v-else>
          <div class="order-list">
            <v-card v-for="order in orders" :key="order.id" flat class="order-card mb-3">
              <div class="d-flex align-center">
                <v-avatar color="amber lighten-4" size="38">
                  <v-icon color="black">mdi-receipt</v-icon>
                </v-avatar>
                <div class="ml-3 mr-2 flex-grow-1 overflow-hidden">
                  <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold text-truncate">#{{ order.dailySerial }}</div>
                    <v-spacer></v-spacer>
                    <div class="text-subtitle-2 font-weight-bold amber--text text--lighten-4">{{ order.amount | priceDisplay }}</div>
                  </div>
                  <div class="text-caption text--secondary mt-1">
                    <v-icon small class="mr-1" color="grey lighten-1">mdi-calendar-clock</v-icon>
                    {{ order.timeText }}
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </template>
      </template>

      <v-alert v-if="error" dense outlined type="error" class="mt-4">
        {{ error }}
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import { Remember } from '@/plugins/firebase'
import {getOrderInfo} from "@/dataLayer/service/api";
import {rotateDailySerial} from "@/dataLayer/service/OrderService";

export default {
  name: 'HistoryOrderPage',
  data () {
    return {
      loading: true,
      error: '',
      orders: [],
      historyList: []
    }
  },
  methods: {
    async reload () {
      this.loading = true
      this.error = ''
      try {
        const idStr = Remember.historyOrderId || ''
        const ids = idStr.split(',').map(s => s.trim()).filter(s => s)
        if (ids.length === 0) {
          this.orders = []
          this.loading = false
          return
        }
        const results = await Promise.all(ids.map(async (id) => {
          try {
            const res = await getOrderInfo(id)
            // Normalize response fields safely
            const billInfo = res?.billInfo || res?.content?.billInfo || {}
            const billOrderInfo = res?.billOrderInfo || res?.content?.billOrderInfo || {}
            const amount = Number(billInfo?.totalPrice || billOrderInfo?.totalPrice || 0)
            const timeText = billInfo.endTime + ' ' + billInfo.endYear
            const dailySerial = rotateDailySerial(billInfo?.dailySerial)
            console.log(dailySerial, 'dailySerial')
            return {
              id,
              amount,
              dailySerial: rotateDailySerial(billInfo?.dailySerial),
              timeText
            }
          } catch (e) {
            return { id, amount: 0, timeText: '—', modeText: '—', modeColor: 'grey lighten-3', summary: this.$t('Error') || 'Error', previewImages: [] }
          }
        }))
        // latest first
        this.orders = results.reverse()
      } catch (e) {
        console.error(e)
        this.error = e?.message || 'Load failed'
      } finally {
        this.loading = false
      }
    },
  },
  mounted () {
    this.reload()
  }
}
</script>

<style scoped>
.history-page {
  min-height: 100vh;
  background-color: #121212;
}
.order-list {
  padding-top: 8px;
}
.order-card {
  background-color: #1e1e1e;
  border-radius: 16px;
  padding: 14px 16px;
}
.empty-state {
  height: calc(100vh - 128px);
}
</style>
